import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logout } from '../../services/authService';
import ConfirmActionModal from '../common/ConfirmActionModal';
import logo from '../../assets/images/logo.png';
import './Header.css';

const Header = () => {
  const [usuario, setUsuario] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const sessionData = sessionStorage.getItem('usuario');
    if (sessionData) {
      setUsuario(JSON.parse(sessionData));
    } else {
      setUsuario(null);
    }
    setMenuAbierto(false);
  }, [location]);

  const handleLogoutClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmLogout = async () => {
    await logout();
    setUsuario(null);
    setShowConfirmModal(false);
    window.location.href = '/';
  };

  const handleCancelLogout = () => {
    setShowConfirmModal(false);
  };

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  const esAdmin = usuario?.type === 'admin';
  const esCliente = usuario?.type === 'cliente';

  // No mostrar header para administradores
  if (esAdmin) {
    return null;
  }

  return (
    <>
      <header className="header">
        <div className="header-container">
          {/* Logo */}
          <div className="logo">
            <img src={logo} alt="Golden Cars" className="logo-img" />
            <div className="logo-text-container">
              <h1 className="logo-text">Golden Cars</h1>
              <span className="logo-slogan">Peritaje & Respaldo Jurídico</span>
            </div>
          </div>
          
          {/* Botón menú hamburguesa - solo visible en móvil */}
          <button className="menu-hamburguesa-header" onClick={toggleMenu}>
            <span className="hamburguesa-linea-header"></span>
            <span className="hamburguesa-linea-header"></span>
            <span className="hamburguesa-linea-header"></span>
          </button>

          {/* Navegación Desktop */}
          <nav className="nav-desktop">
            <ul className="nav-list">
              <li><a href="/">Inicio</a></li>
              {esCliente ? (
                <>
                  <li><a href="/mi-espacio">Mi Espacio</a></li>
                  <li>
                    <button onClick={handleLogoutClick} className="btn-logout">
                      Cerrar Sesión
                    </button>
                  </li>
                </>
              ) : (
                <li><a href="/login" className="btn-login">Iniciar Sesión</a></li>
              )}
            </ul>
          </nav>
        </div>

        {/* Navegación Móvil - Menú desplegable */}
        <nav className={`nav-mobile ${menuAbierto ? 'abierto' : ''}`}>
          <ul className="nav-list-mobile">
            <li><a href="/" onClick={() => setMenuAbierto(false)}>Inicio</a></li>
            {esCliente ? (
              <>
                <li><a href="/mi-espacio" onClick={() => setMenuAbierto(false)}>Mi Espacio</a></li>
                <li>
                  <button onClick={() => {
                    setMenuAbierto(false);
                    handleLogoutClick();
                  }} className="btn-logout-mobile">
                    Cerrar Sesión
                  </button>
                </li>
              </>
            ) : (
              <li><a href="/login" className="btn-login-mobile" onClick={() => setMenuAbierto(false)}>Iniciar Sesión</a></li>
            )}
          </ul>
        </nav>
      </header>

      {/* Modal de confirmación para cerrar sesión */}
      <ConfirmActionModal
        isOpen={showConfirmModal}
        onClose={handleCancelLogout}
        onConfirm={handleConfirmLogout}
        title="Cerrar Sesión"
        message="¿Estás seguro de que deseas cerrar sesión?"
        confirmText="Sí, cerrar sesión"
        cancelText="Cancelar"
      />
    </>
  );
};

export default Header;